// extracted by mini-css-extract-plugin
module.exports = {"title":"TeamInvite_title__3FnT_","container":"TeamInvite_container__12GAC"};